import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPencilAlt, faBan, faPlus, faAngleRight, faAnglesRight, faAnglesLeft, faAngleLeft} from '@fortawesome/free-solid-svg-icons';
import {stillWorkingEmploye} from '../../../services/MadricService';
import {Row, Col} from 'react-bootstrap';
import Spinner from '../../Spinner/Spinner';
import EmployeUpdate from './EmployeUpdate/EmployeUpdate';

/**
 * Vue permettant de modifier et d'ajouter des employés
 * @param {*} props props
 * @return {JSX}
 */
function EmployeView(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEmploye, setSelectedEmploye] = useState(null);
  const [isUpdate, setIsUpdate] = useState(true);
  const [isLoading, setIsLoading] = useState(false);


  /**
   * Permet d'ouvrir le modal
   */
  function openModal() {
    document.getElementById('navbar').classList.add('navbar-hidden');
    document.body.classList.add('modal-open');
    setIsModalOpen(true);
  }

  /**
  * Permet de fermer le modal
  */
  const closeModal = () => {
    document.getElementById('navbar').classList.remove('navbar-hidden');
    document.body.classList.remove('modal-open');
    setIsModalOpen(false);
  };

  /**
   * Permet de retirer un employé
   * @param {*} employe l'employé
   */
  async function stillWorking(employe) {
    setIsLoading(true);
    const res = await stillWorkingEmploye(employe.id);
    setIsLoading(false);
    props.setEmployes(res);
  }

  /**
   * Permet de modifier un enployé
   * @param {*} employe l'employé
   */
  function onClickUpdate(employe) {
    setIsUpdate(true);
    openModal();
    setSelectedEmploye(employe);
  }


  return (
    <div className="employe-container">
      {isLoading && <Spinner />}
      {isModalOpen && (

        <EmployeUpdate isUpdate={isUpdate} selectedEmploye={selectedEmploye} setIsLoading={setIsLoading} closeModal={closeModal} setEmployes={props.setEmployes}/>

      )}
      <h2 className="employe-heading">Liste des employés</h2>
      <input
        type="text"
        value={props.searchInput}
        onChange={props.handleSearchInput}
        className="employe-input-hidden"
        placeholder="Barre de recherche" />
      <div className="employe-wrapper">
        <div className="employe-table">
          <div className="employe-search-container">
            <input
              type="text"
              value={props.searchInput}
              onChange={props.handleSearchInput}
              className="employe-input"
              placeholder="Barre de recherche"/>
            <div className="employe-pagination-buttons">
              <button
                onClick={() => {
                  setIsUpdate(false);
                  openModal();
                }}
                key="+"
                className="employe-pagination-button">
                Ajouter
              </button>
              {[
                <FontAwesomeIcon key="1" icon={faAnglesLeft} />,
                <FontAwesomeIcon key="2" icon={faAngleLeft} />,
                <FontAwesomeIcon key="3" icon={faAngleRight} />,
                <FontAwesomeIcon key="4" icon={faAnglesRight} />,
              ].map((symbol, index) => {
                const newPage =
                  index === 0 ?
                    1 :
                    index === 1 ?
                    props.currentPage - 1 :
                    index === 2 ?
                    props.currentPage + 1 :
                    Math.ceil(props.employes.length / props.pageSize);

                return (
                  <React.Fragment key={index}>
                    <button
                      key={symbol}
                      className="employe-pagination-button"
                      onClick={() => props.handlePageChange(newPage)}
                      disabled={props.isButtonDisabled(symbol)}>
                      {symbol}
                    </button>
                  </ React.Fragment>
                );
              })}
            </div>
          </div>
          <div className="employe-table">
            <Row className="employe-row employe-header">
              <Col md={4} className="employe-cell">
                Nom
              </Col>
              <Col md={4} className="employe-cell">
                Courriel
              </Col>
              <Col md={2} className="employe-cell ">
                Heure par défaut
              </Col>
              <Col md={1} className="employe-cell ">
                Rôle
              </Col>
              <Col md={1} className="employe-cell"></Col>
            </Row>

            {props.displayedEmployes.map((employe, index) => (
              <Row key={index} className='employe-row employe-row-cell-click' style={{backgroundColor: employe.still_working === 1 ? '' : 'red'}}>
                <Col
                  md={4}
                  className="employe-cell employe-cell-click"
                  data-title="Nom">
                  {employe.name}
                </Col>
                <Col
                  md={4}
                  className="employe-cell employe-cell-click"
                  data-title="Courriel">
                  {employe.email}
                </Col>
                <Col
                  md={2}
                  className="employe-cell employe-cell-click"
                  data-title="Heure par défaut">
                  {employe.default_hours_formatted}
                </Col>

                <Col
                  md={1}
                  className="employe-cell employe-cell-click"
                  data-title="Rôle">
                  {employe.is_admin === 0 ? 'Employé' : 'Administrateur'}
                </Col>

                <Col md={1} className="employe-cell employe-cell-click">
                  <FontAwesomeIcon
                    className="employe-icon"
                    icon={faPencilAlt}
                    style={{marginRight: '10px', fontSize: '25px'}}
                    onClick={() => onClickUpdate(employe)} />
                  <FontAwesomeIcon
                    className="employe-icon margin-small"
                    style={{fontSize: '25px'}}
                    icon={employe.still_working === 0 ? faPlus : faBan}
                    onClick={() => stillWorking(employe)} />
                </Col>
              </Row>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployeView;
